export const SUMMARY_TITLE = 'Why This Theme Matters'
export const PREP_TITLE = 'Prep'
export const KEY_WORDS_TITLE = 'Key Words'
export const TEACHER_TIP_TITLE = 'Teaching Notes'
